import React from 'react';
import { LM_TOKENS } from '../../live-monitor/config';

export function LiveMonitorEmpty() {
  return (
    <div
      className="lm-fade-up lm-d-3 flex flex-col items-center gap-6 overflow-hidden rounded-2xl border border-[var(--cream-2)] bg-[var(--cream-1)] text-center shadow-[var(--sh-1)]"
      style={{ padding: '84px 32px 72px' }}
    >
      <div
        className="relative flex items-center justify-center"
        style={{ width: 120, height: 120 }}
      >
        <div className="lm-listen-ring" style={{ animationDelay: '0s' }} />
        <div className="lm-listen-ring" style={{ animationDelay: '1.07s' }} />
        <div className="lm-listen-ring" style={{ animationDelay: '2.13s' }} />
        <div
          className="relative z-[3] rounded-full"
          style={{
            width: 12,
            height: 12,
            background: LM_TOKENS.iriDot,
            boxShadow: `0 0 14px ${LM_TOKENS.greenSoft}, 0 0 28px ${LM_TOKENS.greenWash}`,
          }}
        />
      </div>
      <div>
        <h2 className="m-0 mb-2 text-[28px] font-medium leading-[1.15] tracking-[-0.03em] text-[var(--ink-0)]">
          All <span className="lm-serif text-[32px] font-normal tracking-[-0.015em]">quiet</span>
        </h2>
        <p className="m-0 max-w-[46ch] text-[14px] leading-[1.6] tracking-[-0.005em] text-[var(--ink-2)]">
          Elva isn&apos;t on a call right now. New calls will appear here as they come in.
        </p>
      </div>
    </div>
  );
}
